import {IModalOptions} from "../../common/modals/modal-options.interface";

export class EcaModalOptions implements IModalOptions {
  modalClasses = 'modal-eca';
  noButtonColour = 'transparent';
  noButtonIcon = ['fas', 'times'];
  noButtonText = 'Cancel';
  yesButtonColour = 'success';
  yesButtonIcon =  ['fas', 'check'];
  yesButtonText = 'Yes';
  editButtonIcon = 'fas fa-edit';
}
